// / — the logged-out home page: the Join landing with no module open. The page
// itself is rendered by the _landing layout (JoinLanding); this route owns the
// path and the routing only `/` does, after the layout has sent signed-in
// visitors on.
import { createFileRoute, redirect } from '@tanstack/react-router';
import { takeAuthDrift } from '@/lib/queries/identity';
import { readRememberedLogin } from '@/lib/remembered-login';

export const Route = createFileRoute('/_public/_landing/')({
  beforeLoad: ({ matches, preload }) => {
    // A preload may never be followed, and `takeAuthDrift` consumes the reason
    // the real navigation needs for its banner.
    if (preload) return;
    // A drift-final sign-out is shown once, wherever the visitor reaches `/`
    // from: the reason is consumed here, so it cannot loop.
    const reason = takeAuthDrift();
    if (reason !== null) throw redirect({ to: '/sign-in', search: { reason } });
    // A remembered login marks a returning member, but only on arriving at the
    // site here. Closing a landing panel and the Join tab both navigate to `/`
    // inside the app, and redirecting those would trap the visitor on
    // /sign-in. The root match is `enter` only on the document's first load.
    if (matches[0]?.cause !== 'enter') return;
    if (readRememberedLogin() !== null) throw redirect({ to: '/sign-in' });
  },
  component: () => null,
});
